import script from "./applications.vue?vue&type=script&setup=true&lang=ts"
export * from "./applications.vue?vue&type=script&setup=true&lang=ts"

import "./applications.vue?vue&type=style&index=0&id=845e0988&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-845e0988"]])

export default __exports__